import { api } from '../api'
import { ModelLog } from './models'
import { setToModel } from '@/utils/objects'
import { ServiceWithRFQID } from '@/services/Service'

export * from './models'

const ENDPOINTS = {
  GET: 'RepairExchangeOrderFollowUps/Get',
  GET_DYNAMIC: 'RepairExchangeOrderFollowUps/GetAllDynamic',
  POST: 'RepairExchangeOrderFollowUps/Create',
  PATCH: 'RepairExchangeOrderFollowUps/Patch',
  PUT: 'RepairExchangeOrderFollowUps/Put',
  DELETE: 'RepairExchangeOrderFollowUps/Delete',
  CREATE_FROM_EXISTING_ORDER: 'RepairExchangeOrderFollowUps/CreateFromExistingOrder'
}

const FIELDS_CONFIG = {
  'shipped': {
    label: 'shipped-to-shop',
    type: 'checkbox'
  },
  'shippedDate': {
    label: 'shipped-date',
    type: 'date'
  },
  'quoteReceived': {
    label: 'quote-received',
    type: 'checkbox'
  },
  'quoteReceivedDate': {
    type: 'date',
    label: 'quote-received-date'
  },
  'quoteApproved': {
    label: 'quote-approved',
    type: 'checkbox'
  },
  'quoteApprovedDate': {
    type: 'date',
    label: 'quote-approved-date'
  },
  'unitShipped': {
    label: 'ship-rcvd-by-bax',
    type: 'checkbox'
  },
  'unitShippedDate': {
    label: 'ship-rcvd-by-bax-date',
    type: 'date'
  },
  'standby': {
    label: 'stand-by',
    type: 'select'
  },
  'standbyDate': {
    type: 'date',
    label: 'stand-by-date'
  },
  'estimatedDeliveryDate': {
    label: 'confirmed-edd',
    type: 'date'
  },
  'orderPhaseID': {
    label: 'order-phase',
    type: 'select'
  },
  'phaseDate': {
    label: 'tag-date',
    type: 'date'
  },
  'phasePersonInChargeEmployeeID': {
    label: 'phase-employee',
    type: 'select'
  },
  'receivedDate': {
    label: 'received-date',
    type: 'date'
  },
  'reminderDate': {
    label: 'reminder-date',
    type: 'date'
  },
  'lastInfo': {
    label: 'last-info'
  },
  'customerCompanyID': {
    type: 'select',
    label: 'customer'
  },
  'po': {
    label: 'po'
  },
  'baxpo': {
    label: 'baxpo'
  },
  'supplierCompanyID': {
    type: 'select',
    label: 'supplier'
  },
  'supplierContactID': {
    type: 'select',
    label: 'supplier-contact'
  },
  'partID': {
    type: 'select',
    label: 'part'
  },
  'partSN': {
    label: 'part-SN'
  },
  'price': {
    label: 'price'
  },
  'currencyID': {
    type: 'select',
    label: 'currency'
  },
  'conditionID': {
    type: 'select',
    label: 'condition'
  },
  'customerCompanyDetailID': {
    type: 'select',
    label: 'customer-detail'
  },
  'customerContactID': {
    type: 'select',
    label: 'customer-contact'
  },
  'poDate': {
    type: 'date',
    label: 'po-date'
  },
  'requestedDate': {
    type: 'date',
    label: 'requested-date'
  },
  'rfqTypeID': {
    type: 'select',
    label: 'rfq-type'
  },
  'baxEmployeeID': {
    type: 'select',
    label: 'employee'
  },
  'poIsOpen': {
    type: 'checkbox',
    label: 'po-is-open'
  },
  'shipToCompanyID': {
    type: 'select',
    label: 'ship-to-company'
  },
  'shipToContactID': {
    type: 'select',
    label: 'ship-to-company-contact'
  },
  'shipToCompanyDetailID': {
    type: 'select',
    label: 'ship-to-company-detail'
  },
  'customerForwarderID': {
    type: 'select',
    label: 'customer-forwarder'
  },
  'priorityID': {
    type: 'select',
    label: 'priority'
  },
  'orderRatingScoreID': {
    type: 'select',
    label: 'order-rating-score'
  },
  'paymentTermID': {
    type: 'select',
    label: 'payment-term'
  },
  'observation': {
    label: 'observation'
  }
}

class RepairExchangeOrderFollowUp extends ServiceWithRFQID {
  async updateAllByFilters (filters, data) {
    const filterArray = Object.entries(filters)
    if (filterArray.length === 0) {
      throw new Error('you are trying to update all records')
    }
    await this.getAllDynamic({
      filter: filterArray.map(([key, value]) => `(${key}=="${value}")`).join('&&'),
      select: 'id,orderPhaseID'
    })
  }
  async createFromExistingOrder (data) {
    return api
      .post(`${ENDPOINTS.CREATE_FROM_EXISTING_ORDER}`, data)
  }
  async createLog (data) {
    const _data = setToModel(new ModelLog(), data)
    delete _data['id']

    return api
      .post(`RepairExchangeOrderFollowUpLogs/Create`, _data)
  }
  async updateNotification ({ field, id, labelSelect, value }) {
    const config = FIELDS_CONFIG[field]

    if (!config) {
      return Promise.reject(new Error(`Config is empty`))
    }

    const { label, type } = config
    const { name } = window.app.$store.getters.get('currentEmployee')
    const fieldLabel = window.app.L10n(label)

    let description = ''

    switch (type) {
      case 'date':
      case 'checkbox':
        description = `${name} ${value ? 'checked' : 'unchecked'} the "${fieldLabel}"`
        break
      case 'select':
        description = `${name} ${value ? 'select' : 'clear'} "${labelSelect}" for the "${fieldLabel}"`
        break
      default:
        description = `${name} change the "${fieldLabel}" to "${value}"`
    }

    return this.createLog({ repairExchangeOrderFollowUpID: id, description })
  }
}

export const ServiceRepairExchangeOrderFollowUp = new RepairExchangeOrderFollowUp({
  apiGet: ENDPOINTS.GET,
  apiGetDynamic: ENDPOINTS.GET_DYNAMIC,
  apiPost: ENDPOINTS.POST,
  apiPatch: ENDPOINTS.PATCH,
  apiPut: ENDPOINTS.PUT,
  apiDelete: ENDPOINTS.DELETE
})
